import moment from 'moment-timezone';
import React from 'react';
export var ODDateTimeRenderer = function (props) {
    var value = props.value, format = props.format;
    if (!value) {
        return React.createElement("span", null, "-");
    }
    return React.createElement("span", null, moment(value).format(format));
};
//# sourceMappingURL=ODDateTimeRenderer.js.map